/*
 * 苏州海管家物流科技有限公司（https://www.hgj.com/）.
 * 苏公网安备32059002003385号 © 2015-2023 Hgj.com All Rights Reserved. | 苏ICP备15030950号.
 * @Date: 2023.09.05.
 * @Author
 * @Description 本地 存储 二次封装 .
 **/
/**
 *@Description localStorage 二次封装.
 *@Return .
 **/
export const setStorage = (key: string, value: any) => {
  window.localStorage.setItem(key, JSON.stringify(value || ''))
}

export const getStorage = (key: string) => {
  const storedStr = window.localStorage.getItem(key)
  if (!storedStr) {
    return null
  } else {
    return JSON.parse(storedStr)
  }
}
export const removeStorage = (key: string) => {
  window.localStorage.removeItem(key)
}
export const clearStorage = () => {
  window.localStorage.clear()
}

/**
 *@Description sessionStorage 二次封装.
 *@Return .
 **/
export const setSession = (key: string, value: any) => {
  window.sessionStorage.setItem(key, JSON.stringify(value))
}
export const getSession = (key: string) => {
  const storedStr = window.sessionStorage.getItem(key)
  if (!storedStr) {
    return null
  } else {
    return JSON.parse(storedStr)
  }
}
export const removeSession = (key: string) => {
  window.sessionStorage.removeItem(key)
}
export const clearSession = () => {
  window.sessionStorage.clear()
}
/**
 * window.localStorage 浏览器永久缓存
 * @method set 设置永久缓存
 * @method get 获取永久缓存
 * @method remove 移除永久缓存
 * @method clear 移除全部永久缓存
 */
export const Local = {
  // 设置永久缓存
  set(key: string, val: any) {
    window.localStorage.setItem(key, JSON.stringify(val))
  },
  // 获取永久缓存
  get(key: string) {
    const json: any = window.localStorage.getItem(key)
    return JSON.parse(json)
  },
  // 移除永久缓存
  remove(key: string) {
    window.localStorage.removeItem(key)
  },
  // 移除全部永久缓存
  clear() {
    window.localStorage.clear()
  },
}

/**
 * window.sessionStorage 浏览器临时缓存
 * @method set 设置临时缓存
 * @method get 获取临时缓存
 * @method remove 移除临时缓存
 * @method clear 移除全部临时缓存
 */
export const Session = {
  // 设置临时缓存
  set(key: string, val: any) {
    window.sessionStorage.setItem(key, JSON.stringify(val))
  },
  // 获取临时缓存
  get(key: string) {
    const json: any = window.sessionStorage.getItem(key)
    return JSON.parse(json)
  },
  // 移除临时缓存
  remove(key: string) {
    window.sessionStorage.removeItem(key)
  },
  // 移除全部临时缓存
  clear() {
    window.sessionStorage.clear()
  },
}
